export const SMS_CONFIRMATION = 'smsConfirmation';
export const CAN_SEND_MONEY_BY_CARD_FROM_OTHER_COUNTRY = 'canSendMoneyByCardFromOtherCountry';
export const SHOW_DISCLAIMER = 'showDisclaimer';
export const SHOW_HUAWEI_DISCLAIMER = 'showHuaweiDisclaimer';
export const CAN_SEND_MONEY = 'canSendMoney';
export const SHOW_CHOOSE = 'showChoose';
export const SHOW_WAITING_LIST_DISCLAIMER = 'showWaitingListDisclaimer';
export const SHOW_FROZEN_DISCLAIMER = 'showFrozenDisclaimer';
export const RESTORE_PASSWORD = 'restorePassword';
export const AUTH_TYPE = 'authType';
export const CAN_SEND_MONEY_BY_CARD_FROM_USER_COUNTRY = 'canSendMoneyByCardFromUserCountry';
export const IS_NEW_USER = 'isNewUser';

export const CHEQUE = 'cheque';
export const SHOW_MODAL_TERMS_UPDATE_BLOCK = 'show_modal_terms_update_block';
export const SHOW_MODAL_PROFILE_UPDATE_BLOCK = 'show_modal_profile_update_block';
export const SHOW_MODAL_UNCONFIRMED_TRANSACTION_BLOCK = 'show_modal_unconfirmed_transaction';
export const SHOW_MODAL_KYC_INCREASE_LIMIT_BLOCK = 'show_modal_kyc_increase_limit';
export const SHOW_FORMAT_MESSAGE = 'showFormatMessage';
export const SHOW_NOT_FOUND_MESSAGE = 'showNotFoundMessage';
export const DEEP_LINK_PAYMENT_ID = 'deeplink_payment_id';
export const SHOW_MODAL_KYC_INVALID_BLOCK = 'show_modal_kyc_invalid_block';
export const SHOW_MASTERCARD_PROMO_MODAL = 'show_mastercard_promo_modal';
export const POST_COUNTRY_SELECT_DISCLAIMER = 'postCountrySelectDisclaimer';
export const BONUS_BANNER = 'bonusBanner';

export const STRAPI_API = 'strapiApi';
export const NO_AUTH_STRAPI_MENU = 'noAuthMenu';
export const NEW_NO_AUTH_STRAPI_MENU = 'newNoAuthMenu';
export const NO_AUTH_STRAPI_FOOTER = 'noAuthFooter';
export const RECALCULATE = 'recalculate';
export const COMMISSION = 'commission';
export const DC_SOURCES = 'dcSources';
export const SOURCES_FROM = 'sourcesFrom';
export const SOURCES_TO_BANK_CARD = 'sourcesToBankCard';
export const DOWNLOAD_BUTTONS = 'downloadButtons';
export const NEED_TO_SIGN_MY_ID_TERMS = 'needToSignMyIdTerms';

export const ZENDESK_HELP_DATA = 'zendeskHelpData';

export const NEED_TO_SIGN_LULU_TERMS = 'needToSignLuluTerms';
export const USER_COUNTRY = 'userCountry';
export const INCOMPLETE_TRANSFER = 'incompleteTransfer';
export const PAYMENT_CATEGORY = 'paymentCategory';
